import script from "./Progressbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Progressbar.vue?vue&type=script&setup=true&lang=js"

import "./Progressbar.vue?vue&type=style&index=0&id=68daf853&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68daf853"]])

export default __exports__